module.exports = __webpack_public_path__ + "static/media/girl_happy.b5fa7cff.png";